import { render, staticRenderFns } from "./catalogue-disabled.vue?vue&type=template&id=713d8924&"
import script from "./catalogue-disabled.vue?vue&type=script&lang=js&"
export * from "./catalogue-disabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports